<template>
  <div class="container-fluid">
    <div class="alert alert-danger">
      <h1>THE PAGE YOU WERE LOOKING FOR DOESN'T EXIST.</h1>
      <div>YOU MAY HAVE MISTYPED THE ADDRESS OR THE PAGE MAY HAVE MOVED.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style scoped></style>
